import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Form } from 'reactstrap';
import { TextDropZone } from '../../DropZones/TextDropZone';
import { useInvoiceRecognizerApi } from './InvoiceRecognizerApi';
import { SubmitButton } from '../shared/SubmitButton';
import { AI_UTILITIES } from '../../../constants/aiUtilities';
import { useMountedRef } from '../../../components/hooks/useMountedRef';
import { useNotification } from '../../../components/index';
import { useRepeatProcessingLoader } from '../shared/hooks/useRepeatProcessingLoader';
import { StartTimePicker } from '../shared/StartTimePicker';
import { CommentInput } from '../shared/CommentInput';

export const InvoiceRecognizerLoader = () => {
    const history = useHistory();
    const location = useLocation();
    const [files, setFiles] = useState([]);
    const [comment, setComment] = useState('');
    const [startTime, setStartTime] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isInitializing, setIsInitializing] = useState(false);
    const [defaultOutputFormat] = useState('docx');
    const [outputFormats] = useState([
        { value: 'docx', label: 'DOCX' }
    ]);
    const { submitInvoiceRecognizerRequest } = useInvoiceRecognizerApi();
    const {
        showError,
        showWarning
    } = useNotification();
    const isMounted = useMountedRef();

    useRepeatProcessingLoader({
        locationState: location.state,
        setFiles,
        setIsLoading,
        setIsInitializing,
        showError,
        isMounted,
        onLoaded: (state) => {
            setComment(state.comment || '');
        },
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (files.length === 0) {
            showWarning("Пожалуйста, выберите файлы для обработки");
            return;
        }

        setIsLoading(true);
        try {
            const startTimeString = startTime ? startTime.toISOString() : '';
            const { id, identifier } = await submitInvoiceRecognizerRequest(files, comment, startTimeString);
            if (isMounted.current) {
                history.push({
                    pathname: `${AI_UTILITIES.INVOICE_RECOGNIZER.path}/${identifier}`,
                    state: {
                        id,
                        fileNames: files.map(f => f.file.name),
                        comment: comment
                    }
                });
            }
        } catch (error) {
            showError(error.message);
            if (isMounted.current) {
                setIsLoading(false);
            }
        }
    };

    const handleFilesChange = (newFiles) => {
        if (!isLoading && !isInitializing) {
            setFiles(newFiles);
        }
    };

    return (
        <Form onSubmit={handleSubmit} className="speakers-form-container">
            <CommentInput
                id="invoicerecognizerComment"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                disabled={isLoading || isInitializing}
            />

            <StartTimePicker
                value={startTime}
                onChange={setStartTime}
                disabled={isLoading || isInitializing}
            />

            <TextDropZone
                files={files}
                isLoading={isLoading || isInitializing}
                onFilesChange={handleFilesChange}
                showFormatSelector={true}
                outputFormats={outputFormats}
                defaultOutputFormat={defaultOutputFormat}
                maxFiles={1}
                maxFileSize={10 * 1024 * 1024}
                fileTypesDescription="PDF"
                accept={{ 'application/pdf': ['.pdf'] }}
                showTemplateSelector={false}
            />

            <SubmitButton
                isLoading={isLoading}
                text="Отправить на обработку ИИ"
                disabled={isLoading || isInitializing || files.length === 0}
            />
        </Form>
    );
};